/* * * created By Xu Peng * */
<template>
  <el-date-picker
    size="small"
    v-model="data"
    type="daterange"
    align="right"
    unlink-panels
    @change="handleChange"
    value-format="yyyy-MM-dd"
    range-separator="~"
    :start-placeholder="startplh"
    :end-placeholder="endplh"
  >
  </el-date-picker>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Array]
    },
    startplh: {
      type: String,
      default: '开始时间'
    },
    endplh: {
      type: String,
      default: '结束时间'
    }
  },
  data() {
    return {
      data: this.value
    }
  },
  watch: {
    value(val) {
      this.data = val
    }
  },
  methods: {
    handleChange(val) {
      if (!val) {
        return this.$emit('input', ['', ''])
      }
      this.$emit('input', val)
    }
  }
}
</script>
<style lang="less"></style>
